import DefaultTemplate from './DefaultTemplate';

// Same layout as Default; Booking flow is enabled via activeTemplate === 'booking' in HeroSection
const BookingTemplate = () => <DefaultTemplate />;

export default BookingTemplate;
